import React from 'react'
import News, { type NewsArticle } from '../../../react4xp/components/News'

interface CountyListLayoutProps {
  counties: NewsArticle[]
  heading?: string
}

function CountyListLayout({ counties, heading }: CountyListLayoutProps) {
  return (
    <News
      articles={counties}
      view="three-column"
      background="white"
      heading={heading}
    />
  )
}

export default (props) => <CountyListLayout {...props} />


